var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircleLightSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16.001,
    viewBox: "0 0 16.001 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0 16.001) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chevron-thin-right",
    "data-name": "Icon metro-chevron-thin-right",
    d: "M3.505,4.106.1.564A.333.333,0,0,1,.1.1.325.325,0,0,1,.559.1L4.3,3.872a.333.333,0,0,1,0,.467L.559,8.115a.325.325,0,0,1-.463,0,.333.333,0,0,1,0-.467L3.505,4.106Z",
    transform: "translate(8.212 2.865) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 6.533,
    transform: "translate(4.102)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_93",
    "data-name": "Path 93",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.00042724609375 0.9999971389770508 C 4.140377044677734 0.9999971389770508 0.9999971389770508 4.140377044677734 0.9999971389770508 8.00042724609375 C 0.9999971389770508 11.86047744750977 4.140377044677734 15.00085735321045 8.00042724609375 15.00085735321045 C 11.86047744750977 15.00085735321045 15.00085735321045 11.86047744750977 15.00085735321045 8.00042724609375 C 15.00085735321045 4.140377044677734 11.86047744750977 0.9999971389770508 8.00042724609375 0.9999971389770508 M 8.00042724609375 -1.9073486328125e-06 C 12.41894721984863 -1.9073486328125e-06 16.00085639953613 3.581916809082031 16.00085639953613 8.00042724609375 C 16.00085639953613 12.41894721984863 12.41894721984863 16.00085639953613 8.00042724609375 16.00085639953613 C 3.581916809082031 16.00085639953613 -1.9073486328125e-06 12.41894721984863 -1.9073486328125e-06 8.00042724609375 C -1.9073486328125e-06 3.581916809082031 3.581916809082031 -1.9073486328125e-06 8.00042724609375 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircleLightSm);
export default __webpack_public_path__ + "static/media/arrow-right-circle-light-sm.616ad21d1cf50f6514a80787f33cba78.svg";
export { ForwardRef as ReactComponent };